import { extractTextFromMessageContent } from "../ai-chat-message-utils";
import type { AgentMessage } from "../ai-chat-message-utils";

interface ExportUserMessageProps {
  message: Extract<AgentMessage, { role: "user" }>;
  roleLabel: string;
}


export const ExportUserMessage = ({ message, roleLabel }: ExportUserMessageProps) => (
  <div className="tcw-message tcw-message--user">
    <div className="ecp__card">
      <div className="ecp__message-column">
        <p className="ecp__role-label">{roleLabel}</p>
        <p className="ecp__card-text">
          {extractTextFromMessageContent(message.content)}
        </p>
      </div>
    </div>
  </div>
);
